import { eventCategories } from "../../../mocks/trendData";

const baseMap: Record<string, { bubble: string; link: string }> = {
  primary: {
    bubble: "bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50",
    link: "text-primary-600",
  },
  accent: {
    bubble: "bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50",
    link: "text-accent-700",
  },
  secondary: {
    bubble: "bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50",
    link: "text-secondary-700",
  },
};

export default function Categories() {
  return (
    <section id="channels" className="bg-background-100 py-10 md:py-14">
      <div className="container-x">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="section-kicker">频道分类</span>
            <h2 className="mt-3 font-heading text-xl font-black tracking-tight text-foreground-950 md:text-3xl">
              按主题跟进，不错过你关心的方向
            </h2>
          </div>
          <p className="max-w-sm text-sm text-foreground-600">
            同一类型的争议往往有相似脉络，分类追踪能更快抓住规律、少走弯路。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4">
          {eventCategories.map((cat) => {
            const c = baseMap[cat.base];
            return (
              <a
                key={cat.name}
                href="#feed"
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition hover:border-transparent md:p-5"
              >
                <span className={`flex h-10 w-10 items-center justify-center rounded-md transition-colors ${c.bubble}`}>
                  <i className={`${cat.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 text-sm font-bold text-foreground-950 md:text-base">{cat.name}</h3>
                <p className="mt-1 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{cat.desc}</p>
                <span className={`mt-3 flex items-center gap-1 text-xs font-semibold ${c.link}`}>
                  {cat.count} 条动态跟进
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}